const SolidDivider = () => {
  return (
    <hr className="border-solid border-top-1 border-bottom-none border-black-alpha-90 m-0" />
  );
};

export default SolidDivider;
